import { queryParam } from "../../hooks/use-registered-metadata";

import {
    JTBD,
    PROVISIONING,
    ScreenConfig,
    TEAM_CHOICE,
    TEMPLATE_CHOICE,
    TWC_PAGE_SWITCHER,
    WORK_ON_FIRST
} from "./utils";

export const twcScreenConfig: ScreenConfig = {
    [TEAM_CHOICE]: {
        position: { default: 100 },
        onMount: () => undefined,
        visibility: {
            default: true
        }
    },
    [WORK_ON_FIRST]: {
        position: { default: 200 },
        onMount: () => undefined,
        visibility: {
            default: true
        }
    },
    [JTBD]: {
        position: { default: 250 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.aiLedOnboarding,
                            value: "jira"
                        }
                    ]
                }
            ]
        }
    },
    [TEMPLATE_CHOICE]: {
        position: { default: 260 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.aiLedOnboarding,
                            value: "jira"
                        }
                    ]
                }
            ]
        }
    },
    [TWC_PAGE_SWITCHER]: {
        position: { default: 300 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.jtbdD0Onboarding,
                            value: "jira"
                        }
                    ]
                },
                {
                    conditionalAND: [
                        {
                            key: queryParam.aiLedOnboarding,
                            value: "jira"
                        }
                    ]
                }
            ]
        }
    },
    [PROVISIONING]: {
        position: { default: 400 },
        onMount: () => undefined,
        visibility: {
            default: true
        }
    }
};
